"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4532 9.6818 12.3088 6l-2.1445 3.6818L6 10.5836l2.839 3.1773L8.4097 18l3.8991-1.7182L16.2078 18l-.4292-4.2391 2.8389-3.1773-4.1643-.9018zm.3851 2.1298-1.6697-.3616-.8598-1.4762-.8598 1.4762-1.6697.3616 1.1383 1.2739-.1721 1.6996 1.5633-.6888 1.5633.6888-.1721-1.6996 1.1383-1.2739z"
  })];
};

exports.default = _default;